(function () {
  if (window.__blusafeCompatibilityMiniLoaded) return;
  window.__blusafeCompatibilityMiniLoaded = true;

  var rulesCache = {};

  function fetchJson(url) {
    if (!url) return Promise.resolve(null);
    if (!rulesCache[url]) {
      rulesCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Could not load compatibility rules');
        return response.json();
      });
    }
    return rulesCache[url];
  }

  function readJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || 'null') || fallback;
    } catch (error) {
      return fallback;
    }
  }

  function clear(node) {
    while (node && node.firstChild) node.removeChild(node.firstChild);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function track(eventName, payload) {
    var detail = payload || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, detail));

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish(eventName, detail);
      } catch (error) {
        // Optional Shopify analytics bridge.
      }
    }
  }

  function statusCopy(status) {
    if (status === 'compatible') return 'Fits your door.';
    if (status === 'probably_compatible') return 'May fit - check this.';
    if (status === 'not_compatible') return 'This product is not right for your door.';
    return 'Send photos for review.';
  }

  function productLink(product) {
    if (!product || !product.url) return null;
    var link = el('a', 'bs-btn bs-btn--secondary bs-btn--sm', 'View ' + (product.title || 'product'));
    link.href = product.url;
    link.addEventListener('click', function () {
      track('product_clicked', {
        checker_type: 'mini',
        market: 'uk',
        source_page: window.location.pathname,
        product_handle: product.handle || null,
        recommended_product_families: [product.family]
      });
    });
    return link;
  }

  function initMini(root) {
    var toggle = root.querySelector('[data-compatibility-mini-toggle]');
    var panel = root.querySelector('[data-compatibility-mini-panel]');
    var body = root.querySelector('[data-compatibility-mini-body]');
    var family = root.getAttribute('data-family') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var contactUrl = root.getAttribute('data-contact-url') || '/pages/contact';
    var rulesUrl = root.getAttribute('data-rules-url');
    var products = readJson(root, '[data-compatibility-products]', []);
    var startOpen = root.getAttribute('data-start-open') === 'true';
    var state = {
      answers: { currentFamily: family },
      questionIndex: 0,
      opened: false
    };

    function setOpen(open) {
      if (!panel) return;
      panel.hidden = !open;
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-open', open);
      if (open && !state.opened) {
        state.opened = true;
        track('mini_checker_opened', {
          checker_type: 'mini',
          market: 'uk',
          source_page: window.location.pathname,
          product_handle: productHandle || null
        });
        renderFirstQuestion();
      }
    }

    function applyOption(question, option, rules) {
      state.answers[question.id] = option.value;
      if (option.sets) {
        Object.keys(option.sets).forEach(function (key) {
          state.answers[key] = option.sets[key];
        });
      }

      track('measurement_answered', {
        checker_type: 'mini',
        market: 'uk',
        source_page: window.location.pathname,
        product_handle: productHandle || null,
        question_id: question.id,
        answer: option.value
      });

      var questions = (rules.miniQuestions || {})[family] || [];
      if (state.questionIndex >= questions.length - 1) {
        renderResult(rules);
        return;
      }

      state.questionIndex += 1;
      renderQuestion(rules);
    }

    function renderFooter() {
      var footer = el('div', 'blusafe-compatibility__mini-footer');

      var notSure = el('a', 'blusafe-compatibility__mini-notsure');
      notSure.href = contactUrl;
      var notSureImage = root.getAttribute('data-notsure-image');
      if (notSureImage) {
        var img = document.createElement('img');
        img.src = notSureImage;
        img.alt = '';
        img.width = 56;
        img.height = 56;
        notSure.appendChild(img);
      }
      var notSureCopy = el('span', 'blusafe-compatibility__mini-notsure-copy');
      notSureCopy.appendChild(el('strong', '', 'Not 100% sure?'));
      notSureCopy.appendChild(el('span', '', 'Send us images and we will check your door for you.'));
      notSure.appendChild(notSureCopy);
      notSure.addEventListener('click', function () {
        track('photo_upload_started', {
          checker_type: 'mini',
          market: 'uk',
          source_page: window.location.pathname,
          product_handle: productHandle || null
        });
      });
      footer.appendChild(notSure);

      var fullChecker = el('a', 'blusafe-compatibility__mini-fullchecker', 'Take me to the full compatibility checker');
      fullChecker.href = root.getAttribute('data-checker-url') || '/pages/compatibility-checker';
      fullChecker.addEventListener('click', function () {
        track('mini_checker_full_checker_clicked', {
          checker_type: 'mini',
          market: 'uk',
          source_page: window.location.pathname,
          product_handle: productHandle || null
        });
      });
      footer.appendChild(fullChecker);

      return footer;
    }

    function renderQuestion(rules) {
      clear(body);
      var questions = (rules.miniQuestions || {})[family] || [];
      var question = questions[state.questionIndex];
      if (!question) {
        renderResult(rules);
        return;
      }

      var shell = el('div', 'blusafe-compatibility__mini-question');
      shell.appendChild(el('p', 'blusafe-compatibility__mini-count', 'Question ' + (state.questionIndex + 1) + ' of ' + questions.length));
      shell.appendChild(el('h3', 'blusafe-compatibility__mini-title', question.text));

      var options = el('div', 'blusafe-compatibility__mini-options');
      (question.options || []).forEach(function (option) {
        var button = el('button', 'blusafe-compatibility__mini-option', '');
        button.type = 'button';
        button.appendChild(el('span', 'blusafe-compatibility__option-mark', ''));
        button.appendChild(el('span', 'blusafe-compatibility__option-label', option.label));
        button.addEventListener('click', function () {
          applyOption(question, option, rules);
        });
        options.appendChild(button);
      });

      shell.appendChild(options);
      body.appendChild(shell);
      body.appendChild(renderFooter());
    }

    function renderResult(rules) {
      clear(body);
      var result = window.BlusafeCompatibility.evaluate({
        mode: 'mini',
        productHandle: productHandle,
        answers: state.answers,
        products: products
      });

      var shell = el('div', 'blusafe-compatibility__mini-result blusafe-compatibility__mini-result--' + result.status);
      shell.appendChild(el('h3', 'blusafe-compatibility__mini-result-title', statusCopy(result.status)));

      var reasons = (result.reasons || []).concat(result.missingChecks || [], result.warnings || []);
      if (reasons.length) {
        var list = el('ul', 'blusafe-compatibility__mini-reasons');
        reasons.forEach(function (reason) {
          list.appendChild(el('li', '', reason));
        });
        shell.appendChild(list);
      }

      if (result.accessoryRecommendations && result.accessoryRecommendations.length) {
        result.accessoryRecommendations.forEach(function (item) {
          shell.appendChild(el('p', 'blusafe-compatibility__mini-note', item.title + ': ' + item.reason));
        });
      }

      var actions = el('div', 'blusafe-compatibility__mini-actions');
      if (result.status === 'not_compatible' && result.recommendedProducts.length) {
        var recommended = productLink(result.recommendedProducts[0]);
        if (recommended) actions.appendChild(recommended);
      } else if (result.status === 'photo_required' || result.status === 'not_compatible' || result.status === 'probably_compatible') {
        var photo = el('a', 'bs-btn bs-btn--primary bs-btn--sm', 'Send photos');
        photo.href = contactUrl;
        photo.addEventListener('click', function () {
          track('photo_upload_started', {
            checker_type: 'mini',
            market: 'uk',
            source_page: window.location.pathname,
            product_handle: productHandle || null
          });
        });
        actions.appendChild(photo);
      }

      var restart = el('button', 'bs-btn bs-btn--tertiary bs-btn--sm', 'Check again');
      restart.type = 'button';
      restart.addEventListener('click', function () {
        state.answers = { currentFamily: family };
        state.questionIndex = 0;
        renderQuestion(rules);
      });
      actions.appendChild(restart);
      shell.appendChild(actions);

      var targetFamily = (result.recommendedProducts[0] || {}).family;
      if (!targetFamily && (result.status === 'compatible' || result.status === 'probably_compatible')) {
        targetFamily = family;
      }
      var targetRule = (((rules || {}).products) || []).filter(function (product) {
        return product.family === targetFamily;
      })[0];
      if (targetRule && targetRule.filterTags && targetRule.filterTags.length && result.status !== 'photo_required') {
        var browse = el('a', 'blusafe-compatibility__mini-browse', 'See everything that fits this door type');
        browse.href = ((rules || {}).filterCollectionUrl || '/collections/all') + '/' + targetRule.filterTags.join('+');
        browse.addEventListener('click', function () {
          track('checker_filter_browse', {
            checker_type: 'mini',
            market: 'uk',
            source_page: window.location.pathname,
            product_handle: productHandle || null,
            result_status: result.status,
            filter_tags: targetRule.filterTags
          });
        });
        shell.appendChild(browse);
      }

      body.appendChild(shell);
      body.appendChild(renderFooter());

      track('mini_checker_result_seen', {
        checker_type: 'mini',
        market: 'uk',
        source_page: window.location.pathname,
        product_handle: productHandle || null,
        result_status: result.status,
        recommended_product_families: result.recommendedProducts.map(function (product) { return product.family; }),
        missing_measurements: result.missingChecks,
        confidence_score: result.status === 'compatible' ? 100 : result.status === 'probably_compatible' ? 70 : 30
      });
    }

    function renderFirstQuestion() {
      fetchJson(rulesUrl).then(function (rules) {
        window.BlusafeCompatibility.setRules(rules);
        var rule = (rules.products || []).filter(function (product) {
          return product.family === family;
        })[0];
        state.answers = {
          currentFamily: family,
          lockType: rule ? rule.expectedLockType : ''
        };
        state.questionIndex = 0;
        renderQuestion(rules);
      });
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(panel.hidden);
      });
    }

    if (startOpen) setOpen(true);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-compatibility-mini]')).forEach(initMini);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
